import { render } from "./AdminSelfRegistrationIntakeDetail.vue?vue&type=template&id=62ee968c&scoped=true"
import script from "./AdminSelfRegistrationIntakeDetail.vue?vue&type=script&lang=js"
export * from "./AdminSelfRegistrationIntakeDetail.vue?vue&type=script&lang=js"

import "./AdminSelfRegistrationIntakeDetail.vue?vue&type=style&index=0&id=62ee968c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ee968c"]])

export default __exports__